import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthProvider";
import { PartnerLayout } from "@/layouts/PartnerLayout";
import { RequireProvisioner } from "@/layouts/RequireProvisioner";
import { queryClient } from "@/lib/react-query";
import { BillingPage } from "@/pages/billing/BillingPage";
import { ClientDetailPage } from "@/pages/clients/ClientDetailPage";
import { ClientsPage } from "@/pages/clients/ClientsPage";
import { NewClientPage } from "@/pages/clients/NewClientPage";
import { MembersPage } from "@/pages/members/MembersPage";
import { OverviewPage } from "@/pages/overview/OverviewPage";
import { SignInPage } from "@/pages/SignInPage";

export const App = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<Toaster position="top-right" richColors />
			<BrowserRouter
				future={{
					v7_startTransition: true,
					v7_relativeSplatPath: true,
				}}
			>
				<SignedOut>
					<Routes>
						<Route path="/sign-in/*" element={<SignInPage />} />
						<Route path="*" element={<Navigate to="/sign-in" replace />} />
					</Routes>
				</SignedOut>
				<SignedIn>
					<AuthProvider>
						<Routes>
							<Route element={<PartnerLayout />}>
								<Route index element={<OverviewPage />} />
								<Route path="clients" element={<ClientsPage />} />
								<Route
									path="clients/new"
									element={
										<RequireProvisioner>
											<NewClientPage />
										</RequireProvisioner>
									}
								/>
								<Route path="clients/:teamId" element={<ClientDetailPage />} />
								<Route path="billing" element={<BillingPage />} />
								<Route path="members" element={<MembersPage />} />
								<Route path="*" element={<Navigate to="/" replace />} />
							</Route>
						</Routes>
					</AuthProvider>
				</SignedIn>
			</BrowserRouter>
		</QueryClientProvider>
	);
};
